<template>
	<div class="template_input">
		<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
		<input type="month" v-bind:id="params.name" v-model="value" autocomplete="off" v-on:click="scrollToThisInput" v-bind:min="minDate">
	</div>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'month_input',
	data() {
		return {
			value : ''
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
		minDate : function() {
			let currDate = new Date();
			const month = currDate.getMonth() + 1;
			const date = currDate.getFullYear() + '-' + (month >= 10 ? month : '0' + month);
			if(!this.oldValue) this.value = date;
			return date;
		}
	},
	methods : {
		validate : function(v) {
			return v.trim().length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		scrollToThisInput : function(event) {
			if(this.params.scrollTo) return lib.scrollToElem(event.target);
		}
	},
	watch: {
		value : function(val){
			let v = val.trim();
			if(this.validate(v)) this.notifyUpdate(v);
			else this.notifyUpdate();
		},
		oldValue : {
			handler : function(val){
				if(!val) this.value = '';
			},
			deep : true
		}
	},
	mounted : function(){
		if(this.oldValue) this.value = this.oldValue;
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/month_input.vue